const styles = {
  grid: {
    justifyContent: 'center',
  },
  fieldsContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: 10,
    margin: 0,
  },
  labelSpan: {
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5,
    color: '#455873',
    display: 'block',
  },
  dailyPartsSelection: {
    marginTop: 20,
    textAlign: 'center',
  },
  unSelectedButton: {
    backgroundColor: '#455873',
    color: '#fff',
  },
  form: {
    width: '100%',
  },
  divider: {
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
};

export default styles;
